import { ValidationMessages } from "@/types/functions";

const validationIT: ValidationMessages = {
    'min_length': "{field} deve avere almeno 0:{min} elementi selezionati",
    'max_length': "Il {field} deve avere un massimo di 0:{max} elementi selezionati",
    'multiple': 'Il {field} deve essere un multiplo di 0:{multiple}'
}

export default validationIT
